export const DocumentIcon = ({ color = 'url(#paint0_linear_4_503)' }) => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M8.66675 1.33334H4.00008C3.64646 1.33334 3.30732 1.47382 3.05727 1.72387C2.80722 1.97392 2.66675 2.31305 2.66675 2.66668V13.3333C2.66675 13.687 2.80722 14.0261 3.05727 14.2762C3.30732 14.5262 3.64646 14.6667 4.00008 14.6667H12.0001C12.3537 14.6667 12.6928 14.5262 12.9429 14.2762C13.1929 14.0261 13.3334 13.687 13.3334 13.3333V6.00001M8.66675 1.33334L13.3334 6.00001M8.66675 1.33334V6.00001H13.3334"
            stroke={color} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
        <defs>
            <linearGradient id="paint0_linear_4_503" x1="2.66658" y1="14.6666" x2="15.6748" y2="4.26002" gradientUnits="userSpaceOnUse">
                <stop stopColor="#0083DC" />
                <stop offset="1" stopColor="#0090EA" />
            </linearGradient>
        </defs>
    </svg>
}